<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="聊天记录">
        <div class="row">
          <div class="flex xs6">
            <va-input
                v-model="nickname"
                placeholder="按用户名搜索"
                @input="search"
                removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
        </div>
        <div class="flex xs12">
          <va-data-table
              :fields="fields"
              :data="channelMessage"
              :loading="loading"
              :total-pages="totalPage"
              @page-selected="listChannelMessage"
              api-mode
              :row-class="greyIfDelete"
          >
            <template slot="avatar" slot-scope="props">
              <va-avatar>
                <img :src="formatAvatar(props.rowData.avatar)">
              </va-avatar>
            </template>
            <template slot="nick" slot-scope="props">
              {{ formatNick(props.rowData.nick, props.rowData.isDelete) }}
            </template>
            <template slot="time" slot-scope="props">
              {{ formatTime(props.rowData.time) }}
            </template>

            <template slot="payload" slot-scope="props">
              <div v-if="getPayloadType(props.rowData.payload)==='group_create'">
                <b>{{ props.rowData.nick }}</b> {{ formatPayload(props.rowData.payload) }}
              </div>
              <div v-if="getPayloadType(props.rowData.payload)==='subject'"
                   v-html="formatPayload(props.rowData.payload)">
              </div>
              <template v-if="getPayloadType(props.rowData.payload)==='system'"
                        v-html="formatPayload(props.rowData.payload)">
                <b>{{ formatPayload(props.rowData.payload).name }}</b> {{ formatPayload(props.rowData.payload).desc }}
              </template>
              <template v-if="getPayloadType(props.rowData.payload)==='text'">
                {{ formatPayload(props.rowData.payload) }}
              </template>
              <template v-if="getPayloadType(props.rowData.payload)==='audio'">
                <audio v-bind:src="formatPayload(props.rowData.payload).url"
                       controls="controls"></audio>
              </template>
              <template v-if="getPayloadType(props.rowData.payload)==='image'">
                <va-card
                    overlay
                    :image='formatPayload(props.rowData.payload).url'
                    class="va-card-image"
                    :image-alt="formatPayload(props.rowData.payload).name"
                />
              </template>
              <template v-if="getPayloadType(props.rowData.payload)==='file'">
                <a v-bind:href="formatPayload(props.rowData.payload).url"> {{
                    formatPayload(props.rowData.payload).name
                  }} </a>
              </template>
              <template v-if="getPayloadType(props.rowData.payload)==='video'">
                <video v-bind:src="formatPayload(props.rowData.payload).url"
                       controls="controls" height="200px"></video>
              </template>
            </template>

            <template slot="actions" slot-scope="props">
              <va-popover message="删除" placement="top" v-if="props.rowData.isDelete==0">
                <va-button
                    flat
                    small
                    color="gray"
                    icon="fa fa-trash"
                    @click="deleteModal = true; deleteId=props.rowData.id"/>
              </va-popover>
            </template>
          </va-data-table>
          <va-modal
              v-model="deleteModal"
              title="删除聊天记录"
              okText="提交"
              position="center"
              message="请再次确认是否要删除改聊天记录？"
              @ok="confirmDelete"
          />
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import groupApi from '../../api/group'
import {dateFormat} from '../../utils/common'
import debounce from "lodash/debounce";

export default {
  data() {
    return {
      message: ['Required field'],
      groups: [],
      loading: true,
      next: 0,
      totalPage: 0,
      deleteModal: false,
      deleteId: null,
      pageNumber: 1,
      nickname: null,
      channelId: null,
      channelMessage: []
    }
  },
  computed: {
    fields() {
      return [
        {
          name: '__slot:avatar',
        },
        {
          name: '__slot:nick',
          title: '发言人',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:time',
          title: '发言时间',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
        {
          name: '__slot:payload',
          title: '内容',
          width: '40%',
          dataClass: 'text-left',
          titleClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
      ]
    },
    audioUrl(payload) {
      let data = JSON.parse(payload[0].MsgContent.Data)
      return data.remoteAudioUrl
    },
  },
  created() {
    const params = this.$route.params
    this.channelId = params.channelId
    this.listChannelMessage()
  },
  methods: {
    formatPayload(payload) {
      if (payload instanceof Array) {
        if (payload[0].MsgContent.hasOwnProperty("Desc")) {
          let desc = payload[0].MsgContent.Desc
          if (desc === 'uplpad-img') {
            let data = JSON.parse(payload[0].MsgContent.Data);
            if (data.type.indexOf('image')==0) {
              return {
                "url": data.url,
                "name": data.name
              }
            } else if (data.type.indexOf('application')>=0 || data.type === 'file') {
              return {
                "url": data.url,
                "name": data.name
              }
            } else if (data.type.indexOf('video')==0) {
              return {
                "url": data.url,
                "name": data.name
              }
            }
          } else if (desc === 'video') {
            let data = JSON.parse(payload[0].MsgContent.Data)
            return {
              "url": data.url,
              "name": data.name
            }
          } else if (desc === 'audio') {
            let data = JSON.parse(payload[0].MsgContent.Data)
            return {
              "url": data.remoteAudioUrl
            }
          } else if (desc === 'file') {
            return "【文件】"
          } else if (desc === '') {
            let data = payload[0].MsgContent.Data;
            if (data === 'group_create') {
              return "创建了聊天室"
            }
          } else if (desc === 'Subject') {
            let data = JSON.parse(payload[0].MsgContent.Data);
            let projectName = data.projectName;
            return "你已预约 <b>" + projectName +
                "</b> 导师的咨询，我们会在24小时内联系你；也可以添加篱笆老师微信方便联系：lixiangzhe28"
          }
        } else if (payload[0].MsgContent.hasOwnProperty("Text")) {
          return payload[0].MsgContent.Text
        }
      } else {
        if (!payload.hasOwnProperty("MsgContent")) {
          if (payload.hasOwnProperty("GroupJoinType")) {
            let type = payload.GroupJoinType;
            let name = payload.MsgMemberExtraInfo[0].NickName;
            if (type === 2) {
              return {
                name: name,
                desc: "加入了聊天室"
              }
            } else if (type === 0) {
              return {
                name: name,
                desc: "被踢出了聊天室"
              }
            }
          } else if (payload.hasOwnProperty("OpType")) {
            if (payload.OpType === 6) {
              if (payload.hasOwnProperty("MsgGroupNewInfo")) {
                return {
                  name: "",
                  desc: "群资料已修改"
                }
              }
              let name = payload.MsgOperatorMemberExtraInfo.NickName;
              return {
                name: name,
                desc: "修改了个人资料"
              }
            }
          }
        }
      }
    },
    getPayloadType(payload) {
      if (payload instanceof Array) {
        if (payload[0].MsgContent.hasOwnProperty("Desc")) {
          let desc = payload[0].MsgContent.Desc
          if (desc === 'uplpad-img') {
            let data = JSON.parse(payload[0].MsgContent.Data);
            if (data.type.indexOf('image')==0) {
              return "image"
            } else if (data.type.indexOf('application')>=0) {
              return "file"
            } else if (data.type === 'file') {
              return "file"
            } else if (data.type.indexOf('video')==0) {
              return "video"
            }
          } else if (desc === 'video') {
            return "video"
          } else if (desc === 'audio') {
            return "audio"
          } else if (desc === 'file') {
            return "file"
          } else if (desc === '') {
            return payload[0].MsgContent.Data
          } else if (desc === 'Subject') {
            let data = JSON.parse(payload[0].MsgContent.Data);
            return "subject"
          }
        } else if (payload[0].MsgContent.hasOwnProperty("Text")) {
          // return payload[0].MsgContent.Text
          return "text"
        }
      } else {
        if (!payload.hasOwnProperty("MsgContent")) {
          return "system"
        }
      }
    },
    formatAvatar(avatar) {
      if (avatar == null) {
        return "https://static.libabang.cn/image/20220312/4381cad8a837460c89d9cfd1d34a5735.jpg";
      } else {
        return avatar + '?x-oss-process=style/avatar'
      }
    },
    formatNick(nick,isDel) {
      if (nick == null) {
        return "SYSTEM"
      } else {
        if (isDel == 0){
          return nick
        }else{
          return nick+"【已删除】"
        }
      }
    },
    formatTime(time) {
      return dateFormat('YYYY-mm-dd HH:MM', new Date(time * 1000))
    },
    listChannelMessage(pageNumber = 1) {
      this.loading = true
      const data = {
        pageSize: 20,
        pageNumber: pageNumber,
        groupId: this.channelId,
      }
      if (this.nickname != null) {
        data.nickname = this.nickname
      }
      groupApi.listChannelMessage(data)
          .then(response => {
            console.log(response)
            this.channelMessage = response.messages
            this.totalPage = response.totalPage
            this.loading = false
          })
    },
    confirmDelete() {
      console.log(this.deleteId)
      if (this.deleteId == null) return
      let data = {
        "groupId": this.channelId,
        "messageIds": [this.deleteId]
      }
      console.log(data)
      groupApi.deleteChannelMessage(data)
          .then(response => {
            if (response.success === true) {
              this.listChannelMessage()
            }
          })
    },
    search: debounce(function (nickname) {
      this.nickname = nickname
      if (this.nickname === '') { this.nickname = null }
      this.listChannelMessage()
    }, 400),
    greyIfDelete(data) {
      if(data.isDelete==1) {
        return "deleteClass"
      }
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  margin-bottom: 10px;
}
</style>
